import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import useMediaQuery from '@mui/material/useMediaQuery';
import ListSubheader from '@mui/material/ListSubheader';
import Popper from '@mui/material/Popper';
import { useTheme, styled } from '@mui/material/styles';
import { List, useListRef } from 'react-window';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/TextField": TextField, "@mui/material/Autocomplete": Autocomplete, "@mui/material/useMediaQuery": useMediaQuery, "@mui/material/ListSubheader": ListSubheader, "@mui/material/Popper": Popper, "@mui/material/styles": { useTheme, styled }, "react-window": { List, useListRef }, "@mui/material/Typography": Typography } } });
export default ClientProvider;
